webpackJsonp([1],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      user: null,
      slide: 0,
      sliding: true,
      enlargeFooter: true
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400;
    },
    goTop: function goTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Features__ = __webpack_require__(248);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Tracking-Online®',
      slide: 0,
      sliding: true
    };
  },

  components: { Features: __WEBPACK_IMPORTED_MODULE_0__components_Features__["a" /* default */] },
  methods: {
    onSlideStart: function onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd: function onSlideEnd(slide) {
      this.sliding = true;
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d19ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d3d19ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Features_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d19ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Features_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showGoTop: false
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400;
    },
    goTop: function goTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    },
    jumpTo: function jumpTo(w) {
      this.$router.push(w);
    }
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return null;
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dati: {
        societa: null,
        nome: null,
        cognome: null,
        email: null,
        telefono: null,
        citta: null,
        messaggio: null,
        come: 'motore di ricerca',
        altro: null,
        accetto: false
      },
      alert: {
        loading: false,
        variant: 'primary',
        showing: false,
        message: ''
      },
      hows: ['motore di ricerca', 'banner', 'link su altro sito', 'casualmente', '(altro)'],
      markerpos: {
        lat: 45.529107,
        lng: 9.074632
      },
      showGoTop: false
    };
  },

  computed: {
    showOtherInput: function showOtherInput() {
      return this.dati.come && this.dati.come === '(altro)';
    },
    otherState: function otherState() {
      if (!this.dati.come || this.dati.come !== '(altro)') {
        return true;
      }
      return this.dati.altro && this.dati.altro.length > 0;
    },
    validEmail: function validEmail() {
      if (!this.dati.email) {
        return false;
      }
      var regex = /^\S+@\S+$/;
      var e = regex.exec(this.dati.email);
      return e && e[0];
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    alertError: function alertError(msg) {
      this.alert.loading = false;
      this.alert.message = msg;
      this.alert.variant = 'danger';
      this.alert.showing = true;
      return false;
    },
    checkData: function checkData() {
      if (!this.dati.nome || this.dati.nome.length === 0) {
        return this.alertError('Il campo Nome deve essere compilato');
      }
      if (!this.dati.cognome || this.dati.cognome.length === 0) {
        return this.alertError('Il campo Cognome deve essere compilato');
      }
      if (!this.dati.email || !this.validEmail) {
        return this.alertError('Il campo E-mail deve essere compilato');
      }
      if (!this.dati.messaggio || this.dati.messaggio.length === 0) {
        return this.alertError('Il campo Messaggio deve essere compilato');
      }
      return true;
    },
    sendAlert: function sendAlert(what) {
      this.alert.loading = false;
      this.alert.showing = false;
      switch (what) {
        case 0:
          // loading
          this.alert.message = 'Invio richiesta di contatto...';
          this.alert.variant = 'info';
          this.alert.loading = true;
          break;
        case 1:
          // success
          this.alert.message = 'Richiesta di contatto inviata';
          this.alert.variant = 'success';
          break;
        case 2:
          this.alert.message = 'Non è stato possibile inviare la richiesta';
          this.alert.variant = 'danger';
          break;
      }
      this.alert.showing = true;
    },
    sendRequest: function sendRequest() {
      var _this = this;

      if (!this.alert.loading && this.checkData()) {
        this.sendAlert(0);
        this.$http.post('http://piattaforma.opentracking.it/api/data', this.dati).then(function (response) {
          if (response.status === 200) {
            _this.sendAlert(1);
          } else {
            _this.sendAlert(2);
          }
        }).catch(function (error) {
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
          _this.sendAlert(2);
        });
      }
    },
    handleScroll: function handleScroll(event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400;
    },
    goTop: function goTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clienti: [{ logo: 'cablog_logo.jpg', text: 'Cablog Srl', url: 'https://www.cab-log.it/' }, { logo: 'ellebi_logo.jpg', text: 'Ellebi & A. Autotrasporti', url: 'https://www.ellebiautotrasporti.it/' }, { logo: 'scl_logo.jpg', text: 'Silvano Chiapparoli Logistica Spa', url: 'http://www.chiapparolionline.it' }, { logo: 'pt-visirun.png', text: 'Visirun Spa', url: 'https://www.visirun.com/it/lecosistema-visirun-per-il-controllo-satellitare-integrato/' }, { logo: 'zanardo_logo.jpg', text: 'Zanardo Servizi Logistici Spa', url: 'http://www.zanardo.it/' }, { logo: 'logtrasportisrl.jpg', text: 'Logistica e Trasporti Srl', url: 'http://www.logisticaetrasporti.it' }, { logo: 'logos_srl.png', text: 'LOG-OS S.r.l.', url: 'http://www.zanardo.it/page.php?id=1175' }, { logo: 'Logo_edp.png', text: 'EDP Delivery Service Srl', url: 'http://www.edpdelivery.com/' }],
      old: [{ logo: 'world_logistics.jpg', text: 'World Logistics Srl', url: 'https://www.worldlogistics.it/' }, { logo: 'matras.jpg', text: 'Matras Srl', url: 'https://www.matrasts.it/' }],
      showGoTop: false
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400;
    },
    goTop: function goTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      par_id: 0,
      showGoTop: false
    };
  },

  computed: {
    mlparagraph_title: function mlparagraph_title() {
      var p = 'opentracking.paragraph_' + this.par_id + '.title';
      return new __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__["MLBuilder"](p);
    },
    mlparagraph_text: function mlparagraph_text() {
      var p = 'opentracking.paragraph_' + this.par_id + '.text';
      return new __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__["MLBuilder"](p);
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll(event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400;
    },
    goTop: function goTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    },
    goToPar: function goToPar(w) {
      this.par_id = w;
      var el = document.querySelector('#paragraph');
      if (el) {
        window.scroll({ top: el.offsetTop, behavior: 'smooth' });
      }
    },
    jumpTo: function jumpTo(w) {
      this.$router.push(w);
    }
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Contenuti visionabili',
      slide: 0,
      sliding: true
    };
  },

  computed: {},
  methods: {
    onSlideStart: function onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd: function onSlideEnd(slide) {
      this.sliding = true;
    }
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(396)));

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(400)));

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(404)));

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(409)));

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_i18n_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_gotop_css__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_gotop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_gotop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ml__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB7xkEvT-T-YRL6-hxbzG_sMqVk0H7bZXc',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["e" /* fas */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["d" /* faUserSecret */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["a" /* faCheck */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["c" /* faSpinner */]);
__WEBPACK_IMPORTED_MODULE_9__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_10__fortawesome_free_solid_svg_icons__["b" /* faHome */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_11__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_13_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$lang = 'english';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_2__plugins_i18n_js__["a" /* i18n */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e243412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e243412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"netland-color"},[_c('div',{staticClass:"website-title"},[_c('span',{staticClass:"logo",domProps:{"innerHTML":_vm._s(_vm.$ml.get('menu.title'))}}),_vm._v("\n      "+_vm._s(_vm.$ml.get('menu.subtitle'))+"\n    ")]),_vm._v(" "),_c('b-navbar',{attrs:{"toggleable":"md","type":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav-collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$ml.get('menu.home')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/features"}},[_vm._v(_vm._s(_vm.$ml.get('menu.features')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/credits"}},[_vm._v(_vm._s(_vm.$ml.get('menu.credits')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/contacts"}},[_vm._v(_vm._s(_vm.$ml.get('menu.contacts')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/contents"}},[_vm._v(_vm._s(_vm.$ml.get('menu.contents')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/opentracking"}},[_vm._v(_vm._s(_vm.$ml.get('menu.opentracking')))])],1),_vm._v(" "),_c('b-nav-item',[_c('router-link',{staticClass:"netland-link",attrs:{"to":"/demo"}},[_vm._v(_vm._s(_vm.$ml.get('menu.demo')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('main',[_c('router-view'),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],attrs:{"id":"goTopBtn"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("Top")])],1),_vm._v(" "),_c('footer',{staticClass:"enlarged"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$ml.get('appvue.footer_large'))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(283);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      features: 'Features',
      hello_title: '',
      hello1: 'Don\'t lose control over your deliveries.',
      hello2: '',
      hello3: '',
      home0: 'Tracking-Online ® è un\'applicazione web multi-utente/multi-profilo sviluppata da Netland Srl che informa, gestisce e coordina le attività delle società di Logistica e Trasporti che coinvolgono i loro Clienti (mittenti/mandanti delle spedizioni), la loro attività (sia di logistica che di trasporto) e i Destinatari Finali delle Spedizioni. La gestione di tali attività è possibile grazie all\'ausilio delle forme più comuni di comunicazione elettronica come e-Mail, web, ftp, oppure comunicazione diretta tra i sistemi delle Aziende, sia in modo automatico che non (a discrezione del titolare dell\'applicazione).Tracking-Online® è fornito come Servizio a noleggio e comprende tutto l\'hardware e software necessario nonchè l\'implementazione delle personalizzazioni necessarie ed è in grado di gestire e coordinare tutte le comunicazioni con i Clienti e le Società fornitrici di servizi complementari. Il servizio comprende l\'assistenza non solo al titolare dell\'applicazione ma anche ai suoi Clienti e Fornitori.'
    },
    it: {
      features: 'Caratteristiche',
      hello_title: '',
      hello1: 'Non perdere il controllo delle tue spedizioni.',
      hello2: 'Risparmia tempo e denaro per tutte le comunicazioni.',
      hello3: '',
      home0: 'Tracking-Online ® è un\'applicazione web multi-utente/multi-profilo sviluppata da Netland Srl che informa, gestisce e coordina le attività delle società di Logistica e Trasporti che coinvolgono i loro Clienti (mittenti/mandanti delle spedizioni), la loro attività (sia di logistica che di trasporto) e i Destinatari Finali delle Spedizioni. La gestione di tali attività è possibile grazie all\'ausilio delle forme più comuni di comunicazione elettronica come e-Mail, web, ftp, oppure comunicazione diretta tra i sistemi delle Aziende, sia in modo automatico che non (a discrezione del titolare dell\'applicazione). Tracking-Online® è fornito come Servizio a noleggio e comprende tutto l\'hardware e software necessario nonchè l\'implementazione delle personalizzazioni necessarie ed è in grado di gestire e coordinare tutte le comunicazioni con i Clienti e le Società fornitrici di servizi complementari. Il servizio comprende l\'assistenza non solo al titolare dell\'applicazione ma anche ai suoi Clienti e Fornitori.'
    }
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Features__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tracking__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contacts__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Credits__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OpenTracking__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Contents__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PageNotFound__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Demo__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Legal__ = __webpack_require__(379);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/features',
    name: 'Features',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Features__["a" /* default */]
  }, {
    path: '/tracking',
    name: 'Tracking',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Tracking__["a" /* default */]
  }, {
    path: '/contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Contacts__["a" /* default */]
  }, {
    path: '/credits',
    name: 'Credits',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Credits__["a" /* default */]
  }, {
    path: '/opentracking',
    name: 'OpenTracking',
    component: __WEBPACK_IMPORTED_MODULE_7__components_OpenTracking__["a" /* default */]
  }, {
    path: '/contents',
    name: 'Contents',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Contents__["a" /* default */]
  }, {
    path: '/demo',
    name: 'Demo',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Demo__["a" /* default */]
  }, {
    path: '/legal',
    name: 'Legal',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Legal__["a" /* default */]
  }, {
    path: '*',
    name: 'Not found',
    component: __WEBPACK_IMPORTED_MODULE_9__components_PageNotFound__["a" /* default */]
  }]
}));

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acc25ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3acc25ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('features.title'))}}),_vm._v(" "),_c('h3',{domProps:{"textContent":_vm._s(_vm.$ml.get('features.subtitle'))}}),_vm._v(" "),_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_1.title'),"img-src":"static/img/features/logistics.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_1.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_2.title'),"img-src":"static/img/features/delivery.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_2.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_3.title'),"img-src":"static/img/features/production.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_3.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1)],1),_vm._v(" "),_c('b-card-group',{staticClass:"mt-4",attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_4.title'),"img-src":"static/img/features/interactive-web.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_4.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_5.title'),"img-src":"static/img/features/dynamic-mails.png","align":"center"}},_vm._l((_vm.$ml.get('features.card_5.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_6.title'),"img-src":"static/img/features/web-services.png","align":"center"}},_vm._l((_vm.$ml.get('features.card_6.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1)],1),_vm._v(" "),_c('b-card-group',{staticClass:"mt-4",attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_7.title'),"img-src":"static/img/features/controllo-qualita.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_7.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_8.title'),"img-src":"static/img/features/permissions.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_8.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_9.title'),"img-src":"static/img/features/eventi.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_9.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1)],1),_vm._v(" "),_c('b-card-group',{staticClass:"mt-4",attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_10.title'),"img-src":"static/img/features/kpis-fwm.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_10.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_11.title'),"img-src":"static/img/features/settimane.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_11.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_12.title'),"img-src":"static/img/features/estrazioni.jpg","align":"center"}},_vm._l((_vm.$ml.get('features.card_12.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})}),1)],1),_vm._v(" "),_c('b-card-group',{staticClass:"mt-4",attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"align":"center"}},[_c('b-embed',{staticStyle:{"width":"100%","left":"0"},attrs:{"type":"iframe","aspect":"16by9","src":"/static/vids/piattaforma_ot.mp4","allowfullscreen":""}}),_vm._v(" "),_c('h4',{staticClass:"mt-4 card-title",domProps:{"textContent":_vm._s(_vm.$ml.get('features.card_13.title'))}}),_vm._v(" "),_vm._l((_vm.$ml.get('features.card_13.text')),function(i){return _c('b-card-text',{key:i,domProps:{"textContent":_vm._s(i)}})})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('features.card_14.title'),"img-src":"static/img/shared/opentracking_logo.jpg","align":"center"}},[_vm._l((_vm.$ml.get('features.card_14.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('b-button',{staticClass:"red-button",domProps:{"textContent":_vm._s(_vm.$ml.get('features.card_14.button'))},on:{"click":function($event){return _vm.jumpTo('/opentracking')}}})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_3.title'),"img-src":"static/img/opentracking/plugin.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_3.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_3.read_more')),expression:"$ml.get('opentracking.card_3.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(3)}}})],2)],1),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],attrs:{"id":"goTopBtn"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("Top")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('hello.title'))}}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-carousel',{staticStyle:{"text-shadow":"1px 1px 2px #333"},attrs:{"id":"carousel-1","intervall":4000,"controls":"","indicators":"","img-width":"1024","img-height":"440"},on:{"sliding-start":_vm.onSlideStart,"sliding-end":_vm.onSlideEnd}},[_c('b-carousel-slide',{attrs:{"img-src":"static/img/provaslide3.png"}}),_vm._v(" "),_c('b-carousel-slide',{attrs:{"img-src":"static/img/autostrada2.jpg"}},[_c('p',{staticClass:"mt-4",domProps:{"innerHTML":_vm._s(_vm.$ml.get('hello.first_p'))}})])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"12"}},[_c('p',{staticClass:"p-description",domProps:{"innerHTML":_vm._s(_vm.$ml.get('hello.description'))}})])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('features')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracking_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25acabec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracking_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25acabec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25acabec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracking"},[_c('h1',[_vm._v("Tracking-Online®")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('div',{staticClass:"shadowed-card"},[_c('h3',[_vm._v("Il servizio Tracking-Online® comprende le seguenti funzionalità:")]),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_1')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_2')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_3')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_4')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_5')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_6')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_7')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_8')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_9')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_10')))],1),_vm._v(" "),_c('p',[_c('font-awesome-icon',{attrs:{"icon":"check"}}),_vm._v(_vm._s(_vm.$ml.get('tracking.list_item_11')))],1),_vm._v(" "),_c('b-button',{staticClass:"mt-4 mb-4",attrs:{"variant":"success","href":"/contacts"}},[_vm._v(_vm._s(_vm.$ml.get('tracking.submit')))])],1)]),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_432644eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-432644eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_432644eb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('contacts.title'))}}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8","offset-md":"2","sm":"10","offset-sm":"1","cols":"12","lg":"4","offset-lg":"4"}},[_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.markerpos,"zoom":15}},[_c('GmapMarker',{attrs:{"position":_vm.markerpos,"clickable":true}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"8","offset-md":"2","sm":"10","offset-sm":"1","cols":"12","lg":"4","offset-lg":"4"}},[_c('p',{staticClass:"company-info",domProps:{"innerHTML":_vm._s(_vm.$ml.get('contacts.company_info'))}})])],1),_vm._v(" "),_c('h3',{domProps:{"textContent":_vm._s(_vm.$ml.get('contacts.fill_title'))}}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"8","offset-md":"2","sm":"10","offset-sm":"1","cols":"12","lg":"4","offset-lg":"4"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.company'),"label-for":"input-societa"}},[_c('b-form-input',{attrs:{"id":"input-societa","type":"text","state":_vm.dati.societa},model:{value:(_vm.dati.societa),callback:function ($$v) {_vm.$set(_vm.dati, "societa", $$v)},expression:"dati.societa"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.firstname'),"label-for":"input-nome"}},[_c('b-form-input',{attrs:{"id":"input-nome","type":"text"},model:{value:(_vm.dati.nome),callback:function ($$v) {_vm.$set(_vm.dati, "nome", $$v)},expression:"dati.nome"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.lastname'),"label-for":"input-cognome"}},[_c('b-form-input',{attrs:{"id":"input-cognome","type":"text"},model:{value:(_vm.dati.cognome),callback:function ($$v) {_vm.$set(_vm.dati, "cognome", $$v)},expression:"dati.cognome"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.email'),"label-for":"input-email"}},[_c('b-form-input',{attrs:{"id":"input-email","type":"email","state":_vm.validEmail},model:{value:(_vm.dati.email),callback:function ($$v) {_vm.$set(_vm.dati, "email", $$v)},expression:"dati.email"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.telephone'),"label-for":"input-telefono"}},[_c('b-form-input',{attrs:{"id":"input-teelfono","type":"text"},model:{value:(_vm.dati.telefono),callback:function ($$v) {_vm.$set(_vm.dati, "telefono", $$v)},expression:"dati.telefono"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.city'),"label-for":"input-citta"}},[_c('b-form-input',{attrs:{"id":"input-citta","type":"text"},model:{value:(_vm.dati.citta),callback:function ($$v) {_vm.$set(_vm.dati, "citta", $$v)},expression:"dati.citta"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.message'),"label-for":"text-messaggio"}},[_c('b-form-textarea',{attrs:{"id":"text-messaggio","rows":"3","max-rows":"6"},model:{value:(_vm.dati.messaggio),callback:function ($$v) {_vm.$set(_vm.dati, "messaggio", $$v)},expression:"dati.messaggio"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.how'),"label-for":"select-come"}},[_c('b-form-select',{attrs:{"id":"select-come","options":_vm.$ml.get('contacts.how_options')},model:{value:(_vm.dati.come),callback:function ($$v) {_vm.$set(_vm.dati, "come", $$v)},expression:"dati.come"}})],1)],1)],1),_vm._v(" "),(_vm.showOtherInput)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.how_answer'),"label-for":"input-altro"}},[_c('b-form-input',{attrs:{"id":"input-altro","type":"text","state":_vm.otherState},model:{value:(_vm.dati.altro),callback:function ($$v) {_vm.$set(_vm.dati, "altro", $$v)},expression:"dati.altro"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',{staticClass:"privacy-text",domProps:{"textContent":_vm._s(_vm.$ml.get('contacts.privacy_info'))}}),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$ml.get('contacts.privacy_agree'),"label-for":"check-accetto"}},[_c('b-form-checkbox',{attrs:{"id":"check-accetto"},model:{value:(_vm.dati.accetto),callback:function ($$v) {_vm.$set(_vm.dati, "accetto", $$v)},expression:"dati.accetto"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{staticStyle:{"text-align":"center"},attrs:{"id":"sendBtn","disabled":_vm.alert.loading},on:{"click":_vm.sendRequest}},[_vm._v("\n            "+_vm._s(_vm.$ml.get('contacts.submit'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-alert',{attrs:{"show":_vm.alert.showing,"dismissible":!_vm.alert.loading,"variant":_vm.alert.variant}},[(_vm.alert.loading)?_c('i',{staticClass:"fas fa-spinner fa-spin",staticStyle:{"color":"#999","margin-right":"5px"}}):_vm._e(),_vm._v("\n            "+_vm._s(_vm.alert.message)+"\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],attrs:{"id":"goTopBtn"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("Top")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e65eab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61e65eab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e65eab_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credits"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.$ml.get('credits.title'))}}),_vm._v(" "),_c('b-card-group',{attrs:{"deck":""}},_vm._l((_vm.clienti),function(c,index){return _c('b-card',{key:index,staticClass:"client-card mb-4",attrs:{"img-src":'static/img/clients/' + c.logo}},[_c('b-button',{staticClass:"red-button",attrs:{"href":c.url,"target":"_blank"}},[_vm._v(_vm._s(c.text))])],1)}),1),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],attrs:{"id":"goTopBtn"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("Top")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenTracking_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009388fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenTracking_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-009388fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenTracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009388fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenTracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opentracking"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$ml.get('opentracking.title'))}}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"offset-md":"1","md":"10","sm":"12","cols":"12"}},_vm._l((_vm.$ml.get('opentracking.description')),function(i){return _c('p',{key:i,staticClass:"card-text text-justify",domProps:{"innerHTML":_vm._s(i)}})}),0)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"10","sm":"12","offset-md":"1","cols":"12"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"align":"center"}},[_c('b-embed',{staticStyle:{"width":"100%","left":"0"},attrs:{"type":"iframe","aspect":"16by9","src":"/static/vids/piattaforma_ot.mp4","allowfullscreen":""}}),_vm._v(" "),_c('h4',{staticClass:"mt-4 card-title",domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.card_1.title'))}}),_vm._v(" "),_vm._l((_vm.$ml.get('opentracking.card_1.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_1.read_more')),expression:"$ml.get('opentracking.card_1.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(1)}}})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_2.title'),"img-src":"static/img/shared/opentracking_logo.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_2.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-img',{staticClass:"qr-code-img",attrs:{"src":"static/img/opentracking/frame.png"}})],1)],1),_vm._v(" "),_c('b-card-text',{staticClass:"qr-code-p",domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.card_2.qrcode_text'))}}),_vm._v(" "),_c('a',{staticClass:"qr-code-a mb-4",attrs:{"href":"https://play.google.com/store/apps/details?id=it.netlandsrl.opentracking","target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.$ml.get('opentracking.card_2.qrcode_text'))+"\n          ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_2.read_more')),expression:"$ml.get('opentracking.card_2.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(2)}}})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_3.title'),"img-src":"static/img/opentracking/plugin.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_3.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_3.read_more')),expression:"$ml.get('opentracking.card_3.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(3)}}})],2)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4 mb-4"},[_c('b-col',{attrs:{"offset-md":"2","md":"8","sm":"12","cols":"12"}},[_c('hr')])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"md":"10","sm":"12","offset-md":"1","cols":"12"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_4.title'),"img-src":"static/img/opentracking/qr_code2.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_4.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_4.read_more')),expression:"$ml.get('opentracking.card_4.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(4)}}})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_5.title'),"img-src":"static/img/opentracking/pod_monitor.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_5.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_5.read_more')),expression:"$ml.get('opentracking.card_5.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(5)}}})],2),_vm._v(" "),_c('b-card',{staticClass:"feature-card",attrs:{"title":_vm.$ml.get('opentracking.card_6.title'),"img-src":"static/img/opentracking/foto_riserva.jpg","align":"center"}},[_vm._l((_vm.$ml.get('opentracking.card_6.text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.$ml.get('opentracking.card_6.read_more')),expression:"$ml.get('opentracking.card_6.read_more')"}],staticClass:"read-more",attrs:{"href":"#paragraph"},domProps:{"textContent":_vm._s(_vm.$ml.get('opentracking.read_more'))},on:{"click":function($event){return _vm.goToPar(6)}}})],2)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4 mb-4"},[_c('b-col',{attrs:{"md":"12","sm":"12","cols":"12"}},[_c('hr')])],1),_vm._v(" "),(_vm.par_id>0)?_c('b-row',{attrs:{"id":"paragraph"}},[_c('b-col',{attrs:{"offset-md":"1","md":"10","sm":"12","cols":"12"}},[_c('b-card',{staticClass:"paragraph-card"},[_c('b-card-header',{staticClass:"tracking-bg mb-4",domProps:{"innerHTML":_vm._s(_vm.$ml.get('paragraph_title'))}}),_vm._v(" "),_vm._l((_vm.$ml.get('paragraph_text')),function(i){return _c('b-card-text',{key:i,domProps:{"innerHTML":_vm._s(i)}})})],2)],1)],1):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGoTop),expression:"showGoTop"}],attrs:{"id":"goTopBtn"},on:{"click":function($event){return _vm.goTop()}}},[_vm._v("Top")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contents_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df12db5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contents_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5df12db5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df12db5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('contents.title'))}}),_vm._v(" "),_c('h2'),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"8","offset-md":"2","sm":"10","offset-sm":"1","cols":"12"}},[_c('p',[_vm._v(_vm._s(_vm.$ml.get('contents.sub_title')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"md":"8","offset-md":"2","sm":"10","offset-sm":"1","cols":"12"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"feature-card feat-6",attrs:{"title":"Flyer","img-src":"static/img/PDF.png","align":"center"}},[_c('b-card-text',[_c('a',{attrs:{"href":"static/pdf/flyer_corr.pdf","target":"_blank"}},[_vm._v("Visualizza")]),_vm._v(" il flyer per i corrispondenti\n          ")])],1),_vm._v(" "),_c('b-card',{staticClass:"feature-card feat-6",attrs:{"title":"Manuale APP","img-src":"static/img/PDF.png","align":"center"}},[_c('b-card-text',[_c('a',{attrs:{"href":"static/pdf/opentracking_manuale.pdf","target":"_blank"}},[_vm._v("Visualizza")]),_vm._v(" il manuale di OpenTracking®\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3e3ba0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e3e3ba0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3e3ba0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('b-img',{attrs:{"src":"static/img/nowhere.jpg","fluid":"","alt":"Page not found"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec81f612_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ec81f612"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec81f612_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$ml.get('demo.title'))}}),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"http://demo.tracking-online.it","target":"_blank"}},[_vm._v(_vm._s(_vm.$ml.get('demo.atext1')))]),_vm._v(" "+_vm._s(_vm.$ml.get('demo.text'))+" "),_c('a',{attrs:{"href":"/contacts"}},[_vm._v(_vm._s(_vm.$ml.get('demo.atext2')))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abde0ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-abde0ce8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abde0ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$ml.get('legal.text'))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages_english__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages_italian__ = __webpack_require__(384);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLInstaller"]);

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLCreate"]({
  initial: 'italian',
  save: "production" === 'production',
  languages: [__WEBPACK_IMPORTED_MODULE_2__languages_english__["a" /* english */], __WEBPACK_IMPORTED_MODULE_3__languages_italian__["a" /* italian */]]
}));

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return english; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__);

var english = new __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__["MLanguage"]('english').create({
  lang_tag: 'EN',
  contacts: {
    title: 'Contacts',
    company_info: 'Sede Legale: Via Mac Mahon 9 - 20155 Milano (MI)<br>Sede Operativa: Viale De Gasperi 77 - 20017 Mazzo di Rho (MI)<br>P.IVA: 11766720152Tel. +39 02.99766242 - Fax +39 02.99766243 info@trackingonline.it',
    fill_title: 'Fill in the form to be contacted',
    company: 'Company',
    firstname: 'First name',
    lastname: 'Last name',
    email: 'E-mail address',
    telephone: 'Telephone',
    city: 'City / town',
    message: 'Message',
    how: 'How have you found us?',
    how_options: [{ text: 'search engine', value: 'motore di ricerca' }, { text: 'ad banners', value: 'banner' }, { text: 'link on another website', value: 'link su altro sito' }, { text: 'by chance', value: 'casualmente' }, { text: '(other reason)', value: '(altro)' }],
    how_answer: 'Specify',
    privacy_info: 'Accordingly to EU regulamentation regarding privacy ("GDPR"), we will use your personal data for the sole purpose of marketing',
    privacy_agree: 'I agree',
    submit: 'Submit'
  },
  contents: {
    title: 'Downloadable contents',
    sub_title: 'Here you can find several media, such as videos, images, brochures amd a brief guide of how OpenTracking® works'
  },
  credits: {
    title: 'A few of our references'
  },
  features: {
    title: 'Features',
    subtitle: 'Accesso web multiutente',
    card_1: {
      title: 'Per i corrispondenti o TP',
      text: ['Visione delle spedizioni affidate.', "Possibilità di inserire l'esito dello stato della spedizione con la lista delle causali.", 'Upload del file degli esiti tramite web, email, ftp.', 'Invio diretto degli esiti tramite SOAP o JSON.']
    },
    card_2: {
      title: 'Per i destinatari',
      text: ['Consultazione dello stato della spedizione ricercata per riferimento mittente o progressivo.', 'Visualizzazione dei dettagli con i vari stati di avanzamento della spedizione.', 'Segnalazione dell’anomalia con l’invio della foto del pacco.', 'Richiesta bolla firmata.']
    },
    card_3: {
      title: 'Per le mandanti',
      text: ['Visualizzazione delle proprie spedizioni con i dettagli e lo stato aggiornati in tempo reale.', 'Possibilità di dare disposizione degli avvisi di giacenza.', "Possibilità di ricevere notifiche dell'andamento delle proprie spedizioni."]
    },
    card_4: {
      title: 'Web interattivo',
      text: ['Tracking-Online® si prefigge di leggere i dati direttamente dal sistema centrale e di aggiornarli a seconda delle informazioni ricevute dagli attori della spedizione via scambio file, interazione via web o E-mail dinamica.']
    },
    card_5: {
      title: 'E-mail dinamica',
      text: ["Tracking-Online® oltre ad assicurare l'interscambio dati fra più Aziende, integra lo strumento e-mail per coordinare il ciclo attivo di disposizioni su notifica di un evento.", 'È possibile configurare un flusso/percorso di disposizione e autorizzazione distinto per ogni evento e coinvolgere direttamente il titolare della disposizione. Es. un avviso di giacenza, catalogato automaticamente, può essere inviato direttamente al Mittente/Mandante di una spedizione con la richiesta della disposizione (riconsegnare, reso al mittente, note etc.) che verrà inviata al vettore/trasportatore.']
    },
    card_6: {
      title: 'Interscambio files',
      text: ['Tracking-Online® accetta tutti i tipi di comunicazione Internet (Web, E-mail, FTP) con flussi automatici e normalizzati operando le opportune trascodifiche. Quindi non è necessario modificare alcun database o procedura di generazione ed invio files.', 'a) Comunicazione degli esiti delle spedizioni da parte dei corrispondenti con verifica immediata e conferma d’inserimento.', 'b) Lettura dei borderò da parte di corrispondenti e conferma dell’avvenuta acquisizione.', 'c) Consultazione da parte della mandante dello stato delle spedizioni con i relativi dettagli.']
    },
    card_7: {
      title: 'Interazione con il sistema centrale e controllo qualità',
      text: ['Tracking-Online® è la piattaforma ideale per aggiungere al proprio sistema centrale non solo il colloquio con elementi periferici ma aggiungere funzionalità assenti.', "Internet è lo strumento ideale per creare nuove procedure automatizzate che interagiscono con il ciclo attivo. Si possono aggiungere funzioni che incidono sull'operatività o di monitor della stessa con statistiche approfondite per il controllo operativo e qualitativo dell'Azienda nei confronti dei suoi Clienti e nei confronti dei fornitori di servizi complementari logistici, nonchè fatturazione o autofatturazione."]
    },
    card_8: {
      title: 'Gestione delle permission',
      text: ['Possibilità di gestire granularmente i permessi degli utenti.', 'Per fare ciò abbiamo implementato il sistema dei profili che non sono suddivisi in una gerarchia piramidale, bensì libera.', 'Ad esempio un profilo potrebbe gestire i resi, ma non poter modificare gli utenti, o aggiungere causali, ma non aver potere sulla gestione delle festività']
    },
    card_9: {
      title: 'Gestione delle causali',
      text: ['Totale libertà di creare causali di eventi da monitorare e gestione delle permission di lettura e scrittura di ogni singolo componente di una pagina.', 'Esse possono essere categorizzate e considerate definitive o non definitive', 'Se al sistema perviene un evento con causale definitiva non importerà eventi successivi, a meno che questo non venga annullato, in tal caso la spedizione sarà nuovamente in corso.']
    },
    card_10: {
      title: 'Gestione dei KPI',
      text: ['Possibilità di impostare le regole dei KPI e controllare il rispetto di essi tramite il Dashboard', 'Modulo delle statistiche con le percentuali di esito aggiornate in tempo reale per mantenere al top la qualità del servizio.', 'Notifiche personalizzate per intervenire su criticità.']
    },
    card_11: {
      title: 'Statistiche',
      text: ['Gestione delle statistiche altamente personalizzata:', 'Dashboard customizzabile con i grafici della BI (Business Intelligence)', 'Possibilità di scaricare il dashboard selezionato in pdf e di riceverlo in automatico tramite e-mail.']
    },
    card_12: {
      title: 'Estrazioni automatiche pianificabili',
      text: ["Gestione delle estrazioni ripetitive e della loro schedulazione per l'invio in automatico via e-mail ai destinatari configurati."]
    },
    card_13: {
      title: 'Connessione alla piattaforma logistica www.OpenTracking.it',
      text: ["Tracking-Online® interagisce con la piattaforma logistica OpenTracking® nella quale vengono pubblicate le spedizioni e tutti gli eventi che ogni protagonista della supply chain genera ed interscambia fino ad arrivare all'esito finale."]
    },
    card_14: {
      title: 'APP OpenTracking',
      text: ['', '']
    }
  },
  hello: {
    title: '',
    first_p: 'Don\'t lose cotrol over your deliveries.<br>Save time and money in all your communications',
    description: "Tracking-Online ® è un'applicazione web multi-utente/multi-profilo sviluppata da Netland Srl che informa, gestisce e coordina le attività delle società di Logistica e Trasporti che coinvolgono i loro Clienti (mittenti/mandanti delle spedizioni), la loro attività (sia di logistica che di trasporto) e i Destinatari Finali delle Spedizioni. La gestione di tali attività è possibile grazie all'ausilio delle forme più comuni di comunicazione elettronica come e-Mail, web, ftp, oppure comunicazione diretta tra i sistemi delle Aziende, sia in modo automatico che non (a discrezione del titolare dell'applicazione).<br><br>Tracking-Online® è un prodotto concesso in licenza d'uso che comprende il software e le personalizzazioni necessarie ed è in grado di gestire e coordinare tutte le comunicazioni con i Clienti mandanti e le Società fornitrici di servizi complementari (logistica, trasporti e distribuzione)."
  },
  help: {},
  menu: {
    title: 'Tracking-Online<sup>®</sup>',
    subtitle: 'Version 2.0 is now available',
    contacts: 'Contacts',
    contents: 'Contents',
    credits: 'Credits',
    features: 'Features',
    home: 'Home',
    opentracking: 'OpenTracking®',
    tracking: 'Tracking-Online',
    presentation: 'Presentation'
  },
  opentracking: {
    title: 'OpenTracking<sup>®</sup>',
    description: ['By using OpenTracking<sup>®</sup> platform, this APP allows a company to hand over orders to drivers outside the company.', 'Drivers can hand deliveries given by several companies using one single smartphone and the result along with a P.O.D. (Proof of Delivery) and pics will be sent back to the top giving each and every actor of the delivery what is due to them.'],
    read_more: 'Read more',
    card_1: {
      title: 'Platform',
      text: []
    },
    card_2: {
      title: 'APP',
      text: []
    },
    card_3: {
      title: 'Plug In',
      text: []
    },
    card_4: {
      title: 'QR Code',
      text: []
    },
    card_5: {
      title: 'Proof of Delivery (POD)',
      text: []
    },
    card_6: {
      title: 'Foto riserva',
      text: []
    },
    paragraph_1: {
      title: 'Piattaforma OpenTracking<sup>®</sup>',
      text: []
    },
    paragraph_2: {
      title: 'APP OpenTracking',
      text: []
    },
    paragraph_3: {
      title: 'Plug In',
      text: []
    },
    paragraph_4: {
      title: 'QR Code',
      text: []
    },
    paragraph_5: {
      title: 'Proof of Delivery (POD)',
      text: []
    },
    paragraph_6: {
      title: 'Foto riserva',
      text: []
    }
  },
  tracking: {
    title: 'Tracking-Online®',
    list_title: 'Tracking-Online® comes with the following features:',
    list_item_1: 'Management of users and respective profiles',
    list_item_2: 'Powerful search functionality',
    list_item_3: 'Delivery details',
    list_item_4: 'Current/past held ware showcase and management',
    list_item_5: 'Possibility to give instruction on held ware',
    list_item_6: 'Management of orders with a mandatory delivery date',
    list_item_7: 'Interactive and automatic compilation of discharge reports including anomalies',
    list_item_8: 'Invio e Ricezione compiti e esiti secondo le specifiche accordate per ogni utente',
    list_item_9: 'a Barcode scanner to send a shipment outcome',
    list_item_10: 'Customizations for each and every user',
    list_item_11: 'Quality statistics',
    submit: 'Ask for a demo'
  },
  legal: {
    text: 'L\'utilizzo non autorizzato del presente messaggio \xE8 vietato e potrebbe costituire reato.<br>\nSe il presente messaggio non e\' a Lei indirizzato, Le saremmo grati se, via e-mail, ne comunicasse l\'errata ricezione.<br>\nIl contenuto del presente messaggio non deve essere considerato come trasmesso o autorizzato da NETLand.<br>\nNETLand non si assume alcuna responsabilit\xE0 per eventuali intercettazioni, modifiche o danneggiamenti del presente messaggio e-mail.<br><br>\nThe information contained in this message is intended only for use of the individual(s) named above and may contain confidential, proprietary or legally privileged information.<br>\nNo confidentiality or privilege is waived or lost by any mistransmission. if you are not the intended recipient of this message you are hereby notified that you must not use, disseminate, copy it in any form or take any action in reliance of it. If you have received this message in error please delete it and any copies of it and notify the sender immediately.'
  }
});


/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return italian; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__);

var italian = new __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__["MLanguage"]('italian').create({
  lang_tag: 'IT',
  appvue: {
    footer_small: 'Copyright © 1998-2019 NETLand srl',
    footer_large: 'Copyright © 1998-2019 NETLand srl<br>Sede Legale: Via Mac Mahon 9 - 20155 Milano (MI) Sede Operativa: Viale De Gasperi 77 - 20017 Mazzo di Rho (MI)<br>P.IVA: 11766720152 - Reg. Imprese: MI-1996-739837 - Capitale sociale: Euro 100.000,00 i.v.<br>Tel. +39 02.99766242 - Fax +39 02.99766243 E-mail info@tracking-online.it'
  },
  contacts: {
    title: 'Contatti',
    company_info: 'Sede Legale: Via Mac Mahon 9 - 20155 Milano (MI)<br>Sede Operativa: Viale De Gasperi 77 - 20017 Mazzo di Rho (MI)<br>P.IVA: 11766720152 - Tel. +39 02.99766242 - Fax +39 02.99766243 info@tracking-online.it',
    fill_title: 'Compila il modulo per essere contattato.',
    company: 'Società',
    firstname: 'Nome',
    lastname: 'Cognome',
    email: 'Indirizzo e-mail',
    telephone: 'Telefono',
    city: 'Località',
    message: 'Messaggio',
    how: 'Come sei arrivato qui?',
    how_options: ['motore di ricerca', 'banner', 'link su altro sito', 'casualmente', '(altro)'],
    how_answer: 'Specificare',
    privacy_info: 'Ai sensi di quanto disposto dal regolamento UE 679/2016 ("GDPR"), acconsento al trattamento dei miei dati personali per essere ricontattato',
    privacy_agree: 'Accetto',
    submit: 'Invia'
  },
  contents: {
    title: 'Contenuti visionabili',
    sub_title: 'In questa pagina potete trovare varii media, tra cui brochure esplicative, video, immagini ed una breve guida del funzionamento della piattaforma OpenTracking®'
  },
  credits: {
    title: 'Alcune nostre referenze'
  },
  demo: {
    title: 'Accesso alla demo',
    atext1: 'Accedi',
    text: 'alla demo con le tue credenziali oppure richiedile',
    atext2: 'qua'
  },
  features: {
    title: 'Caratteristiche',
    subtitle: 'Accesso web multiutente',
    card_1: {
      title: 'Per i corrispondenti o TP',
      text: ['Visione delle spedizioni affidate.', "Possibilità di inserire l'esito dello stato della spedizione con la lista delle causali.", 'Upload del file degli esiti tramite web, email, ftp.', 'Invio diretto degli esiti tramite SOAP o JSON.']
    },
    card_2: {
      title: 'Per i destinatari',
      text: ['Consultazione dello stato della spedizione ricercata per riferimento mittente o progressivo.', 'Visualizzazione dei dettagli con i vari stati di avanzamento della spedizione.', 'Segnalazione dell’anomalia con l’invio della foto del pacco.', 'Richiesta bolla firmata.']
    },
    card_3: {
      title: 'Per le mandanti',
      text: ['Visualizzazione delle proprie spedizioni con i dettagli e lo stato aggiornati in tempo reale.', 'Possibilità di dare disposizione degli avvisi di giacenza.', "Possibilità di ricevere notifiche dell'andamento delle proprie spedizioni."]
    },
    card_4: {
      title: 'Web interattivo',
      text: ['Tracking-Online® si prefigge di leggere i dati direttamente dal sistema centrale e di aggiornarli a seconda delle informazioni ricevute dagli attori della spedizione via scambio file, interazione via web o E-mail dinamica.']
    },
    card_5: {
      title: 'E-mail dinamica',
      text: ["Tracking-Online® oltre ad assicurare l'interscambio dati fra più Aziende, integra lo strumento e-mail per coordinare il ciclo attivo di disposizioni su notifica di un evento.", 'È possibile configurare un flusso/percorso di disposizione e autorizzazione distinto per ogni evento e coinvolgere direttamente il titolare della disposizione. Es. un avviso di giacenza, catalogato automaticamente, può essere inviato direttamente al Mittente/Mandante di una spedizione con la richiesta della disposizione (riconsegnare, reso al mittente, note etc.) che verrà inviata al vettore/trasportatore.']
    },
    card_6: {
      title: 'Interscambio files',
      text: ['Tracking-Online® accetta tutti i tipi di comunicazione Internet (Web, E-mail, FTP) con flussi automatici e normalizzati operando le opportune trascodifiche. Quindi non è necessario modificare alcun database o procedura di generazione ed invio files.', 'a) Comunicazione degli esiti delle spedizioni da parte dei corrispondenti con verifica immediata e conferma d’inserimento.', 'b) Lettura dei borderò da parte di corrispondenti e conferma dell’avvenuta acquisizione.', 'c) Consultazione da parte della mandante dello stato delle spedizioni con i relativi dettagli.']
    },
    card_7: {
      title: 'Interazione con il sistema centrale e controllo qualità',
      text: ['Tracking-Online® è la piattaforma ideale per aggiungere al proprio sistema centrale non solo il colloquio con elementi periferici ma aggiungere funzionalità assenti.', "Internet è lo strumento ideale per creare nuove procedure automatizzate che interagiscono con il ciclo attivo. Si possono aggiungere funzioni che incidono sull'operatività o di monitor della stessa con statistiche approfondite per il controllo operativo e qualitativo dell'Azienda nei confronti dei suoi Clienti e nei confronti dei fornitori di servizi complementari logistici, nonchè fatturazione o autofatturazione."]
    },
    card_8: {
      title: 'Gestione delle permission',
      text: ['Possibilità di gestire granularmente i permessi degli utenti.', 'Per fare ciò abbiamo implementato il sistema dei profili che non sono suddivisi in una gerarchia piramidale, bensì libera.', 'Ad esempio un profilo potrebbe gestire i resi, ma non poter modificare gli utenti, o aggiungere causali, ma non aver potere sulla gestione delle festività']
    },
    card_9: {
      title: 'Gestione delle causali',
      text: ['Totale libertà di creare causali di eventi da monitorare e gestione delle permission di lettura e scrittura di ogni singolo componente di una pagina.', 'Esse possono essere categorizzate e considerate definitive o non definitive', 'Se al sistema perviene un evento con causale definitiva non importerà eventi successivi, a meno che questo non venga annullato, in tal caso la spedizione sarà nuovamente in corso.']
    },
    card_10: {
      title: 'Gestione dei KPI',
      text: ['Possibilità di impostare le regole dei KPI e controllare il rispetto di essi tramite il Dashboard', 'Modulo delle statistiche con le percentuali di esito aggiornate in tempo reale per mantenere al top la qualità del servizio.', 'Notifiche personalizzate per intervenire su criticità.']
    },
    card_11: {
      title: 'Statistiche',
      text: ['Gestione delle statistiche altamente personalizzata:', 'Dashboard customizzabile con i grafici della BI (Business Intelligence)', 'Possibilità di scaricare il dashboard selezionato in pdf e di riceverlo in automatico tramite e-mail.']
    },
    card_12: {
      title: 'Estrazioni automatiche pianificabili',
      text: ["Gestione delle estrazioni ripetitive e della loro schedulazione per l'invio in automatico via e-mail ai destinatari configurati."]
    },
    card_13: {
      title: 'Connessione alla piattaforma logistica www.OpenTracking.it',
      text: ["Tracking-Online® interagisce con la piattaforma logistica OpenTracking® nella quale vengono pubblicate le spedizioni e tutti gli eventi che ogni protagonista della supply chain genera ed interscambia fino ad arrivare all'esito finale."]
    },
    card_14: {
      title: 'APP OpenTracking',
      text: ['Scopri i suoi vantaggi e richiedi una demo'],
      button: 'Vai'
    }
  },
  hello: {
    title: 'Tracking-Online®',
    first_p: 'Non perdere il controllo delle tue spedizioni.<br>Risparmia tempo e denaro per tutte le comunicazioni.',
    description: "Tracking-Online ® è un'applicazione web multi-utente/multi-profilo sviluppata da Netland Srl che informa, gestisce e coordina le attività delle società di Logistica e Trasporti che coinvolgono i loro Clienti (mittenti/mandanti delle spedizioni), la loro attività (sia di logistica che di trasporto) e i Destinatari Finali delle Spedizioni. La gestione di tali attività è possibile grazie all'ausilio delle forme più comuni di comunicazione elettronica come e-Mail, web, ftp, oppure comunicazione diretta tra i sistemi delle Aziende, sia in modo automatico che non (a discrezione del titolare dell'applicazione).<br><br>Tracking-Online® è un prodotto concesso in licenza d'uso che comprende il software e le personalizzazioni necessarie ed è in grado di gestire e coordinare tutte le comunicazioni con i Clienti mandanti e le Società fornitrici di servizi complementari (logistica, trasporti e distribuzione)."
  },
  help: {},
  menu: {
    title: 'Tracking-Online<sup>®</sup>',
    subtitle: 'È arrivata la versione 2.0',
    contacts: 'Contatti',
    contents: 'Contenuti',
    credits: 'Referenze',
    features: 'Caratteristiche',
    home: 'Home',
    opentracking: 'OpenTracking®',
    tracking: 'Tracking-Online',
    presentation: 'Presentazione',
    demo: 'DEMO'
  },
  opentracking: {
    title: 'OpenTracking<sup>®</sup>',
    description: ['OpenTracking<sup>®</sup> è una piattaforma web multiutente sviluppata da NETLand S.r.l. che informa, gestisce e coordina le attività di tutti i protagonisti della Logistica e Trasporti.'],
    demo_button: 'Richiedi la demo',
    read_more: 'Per saperne di più',
    cards: [{
      title: 'Piattaforma',
      text: []
    }, {
      title: 'APP',
      text: []
    }],
    card_1: {
      title: 'Piattaforma',
      text: ["Usando la piattaforma OpenTracking<sup>®</sup> che risiede nel Cloud, questa APP permette l'Estensione del prodotto Tracking-Online<sup>®</sup> anche agli autisti non propri.", "Tramite il QRCode o l'inserimento manuale è possibile rintracciare una spedizione che si ha a bordo.", "Gli autisti possono esitare spedizioni affidate da multipli Mandanti con un solo telefono, e far pervenire sia l'esito che il P.O.D. (Proof of Delivery) al mandante."],
      read_more: true
    },
    card_2: {
      title: 'APP',
      text: ["Con l'APP OpenTracking<sup>®</sup> puoi catturare l'esito delle tue spedizioni comodamente dal tuo smartphone.", 'Gli attori della filiera potranno vedere gli eventi e ricevere il POD con la firma per il loro spettro di competenza.'],
      qrcode_text: 'Installala nel tuo smartphone',
      read_more: true
    },
    card_3: {
      title: 'Plug In',
      text: ['Il Plug In fa comunicare i vostri sistemi con la piattaforma OpenTracking<sup>®</sup>:', '<ol><li>Invia gli ordini</li><li>Scarica gli eventi</li></ol>', 'Permettendo di impostare la fonte dalla quale leggere i dati e il tracciato con cui si vuole riceverli una volta elaborati'],
      read_more: false
    },
    card_4: {
      title: 'BAR Code / QR Code',
      text: ["I BAR Code e QR Code permettono all'autista di assegnarsi una spedizione che non ha ancora nella lista caricata sullo smartphone oppure recuperarla velocemente per poterla esitare"],
      read_more: false
    },
    card_5: {
      title: 'Proof of Delivery (POD)',
      text: ["Il POD è il documento che attesta l'avvenuta consegna / scarico di una spedizione con l'indicazione dei dati che consentono l'identificazione univoca dell'ordine, uniti a dati di geolocalizzazione e attestazione della ricezione del destinatario"],
      read_more: true
    },
    card_6: {
      title: 'Foto riserva',
      text: ["Le foto riserva permettono all'autista di comunicare in modo veloce il motivo della consegna parziale / con riserva, in modo che chi di dovere può intervenire tempestivamente sulla determinazione del destino dei colli rifiutati."],
      read_more: false
    },
    paragraph_1: {
      title: 'Piattaforma OpenTracking<sup>®</sup>',
      text: ['<h5>Vantaggi generali</h5>', "<ol><li>Si paga a consumo per ogni riga che effettivamente si ottiene.</li><li>Non si deve investire nei smartphone, si usano quelli dei drivers.</li><li>Si interfaccia con ogni tipo di software o tracciato, persino con un semplice foglio Excel.</li><li>Prevede la gestione dei Pallet lasciati / ritirati nelle sue diverse tipologie.</li><li>Ha un sistema di notifiche push ai driver alle quali possono rispondere.</li><li>Traccia la geoposizione di ogni veicolo scarico per trovare il più idoneo alla missione da assegnare.</li><li>Permette di borderizzare tramite la scansione di un QR Code direttamente dallo smartphone.</li><li>Il ritorno dell'esito è garantito convalidato e si rende disponibile il POD con data e orario, mappa, latitudine, longitudine e firma.</li><li>È possibile inserire la personalizzazione con il logo desiderato.</li></ol>", '<h5>Vantaggi per i Transit Point</h5>', "<ol><li>I Transit Point usando l'APP OpenTracking<sup>®</sup> oltre a poter esitare la merce proveniente dalle mandanti, ricevono gli esiti e i POD personalizzati relativi.</li><li>Tramite uno scanner da tavolo o uno smartphone il Transit Point che riceve il documento con la merce da distribuire può segnalare l'avvenuta presa in carico e la relativa uscita per consegna gestendo gli stadi intermedi di ogni spedizione.</li></ol>", '<h5>Vantaggi per gli autisti</h5>', "Tutta la progettazione è stata effettuata per semplificare l'utilizzo da parte degli Autisti in modo INTUITIVO e MULTILINGUA.<ol><li>Gli autisti non devono contribuire di loro tasca per utilizzare l'APP.</li><li>Possono gestire diverse mandanti con lo stesso smartphone.</li><li>In fase di collegamento scelgono con che mandante lavorare e possono sempre cambiare selezione in itinere</li><li>Possono ricevere notifiche push on the fly e dare risposta</li><li>Possono indicare quando sono scarichi per rendersi disponibili ad effettuare ritiri data la loro gelocalizzazione</li><li>Possono esitare più di una spedizione alla volta tramite l'Esitazione Multipla in caso di più ordini per lo stesso destinatario, con un'unica firma ed ognuna con il suo POD</li></ol>", '<h5>Altre considerazioni frutto della nostra esperienza</h5>', "<ol><li>Una fotografia della bolla firmata molte volte non è sufficiente, a volte è sfocata, storta, tagliata, incompleta e l'autista può giustamente dire di non essere un fotografo!</li><li>Capita spesso che i destinatari (a volte strutture ospedaliere) devono prendersi del tempo per poter controllare e confermare l'esattezza del ricevuto confrontandolo con l'ordine.</li><li>Molte volte le discordanze tra l'ordine effettuato e quello inviato non sono attribuibili alla società di Logistica o di Trasporti.</li><li>La consa più sensata è emettere un POD (Proof of Delivery) che certifichi l'avvenuta consegna nei tempi previsti.</li></ol>"]
    },
    paragraph_2: {
      title: 'APP OpenTracking',
      text: ["<h5>Funzionalità dell'APP", "<ol><li>Visualizza le spedizioni in ordine di consegna / ritiro e ne cattura l'esito.</li><li>Ogni evento viene registrato con data e orario, posizione GPS e - in caso di esito definitivo - firma del destinatario</li><li>Utilizza la fotocamera per scattare foto di consegne parziali / riserva.</li><li>Permette di firmare direttamente sul dispositivo</li><li>La firma viene automaticamente applicata alla bolla</li><li>Provvede alla pubblicazione in tempo reale di eventi, foto e POD sulla piattaforma OpenTracking<sup>®</sup></li></ol>"]
    },
    paragraph_3: {
      title: 'Plug In',
      text: []
    },
    paragraph_4: {
      title: 'QR Code',
      text: []
    },
    paragraph_5: {
      title: 'Proof of Delivery (POD)',
      text: ['Il POD è totalmente personalizzabile, con logo della proprià società e scelta dei dati e della loro collocazione nella pagina.', 'Esso può anche essere inviato ai propri clienti o vettori tramite la funzionalità di invio resa disponibile dalla piattaforma OpenTracking<sup>®</sup>.']
    },
    paragraph_6: {
      title: 'Foto riserva',
      text: []
    }
  },
  tracking: {
    title: 'Tracking-Online®',
    list_title: 'Il prodotto Tracking-Online® comprende le seguenti funzionalità:',
    list_item_1: 'Gestione Utenti e relativi Profili',
    list_item_2: 'Motore di ricerca esaustivo',
    list_item_3: 'Dettagli Spedizioni',
    list_item_4: 'Visualizzazione Giacenze aperte e storico',
    list_item_5: 'Disposizioni Interattive su Giacenza via web o e-mail',
    list_item_6: 'Gestione Tassativa e cambio tassativa',
    list_item_7: 'Compilazione Interattiva o Automatica Verbale di Scarico con eventuali anomalie',
    list_item_8: 'Invio e Ricezione compiti e esiti secondo le specifiche accordate per ogni utente',
    list_item_9: 'Integrazione esiti con lettura Barcode presente sulle bolle',
    list_item_10: 'Personalizzazione Visualizzazioni per ogni utente',
    list_item_11: 'Statistiche Operative e Qualitative',
    submit: 'Richiedi la demo'
  },
  legal: {
    text: 'L\'utilizzo non autorizzato del presente messaggio \xE8 vietato e potrebbe costituire reato.<br>\nSe il presente messaggio non e\' a Lei indirizzato, Le saremmo grati se, via e-mail, ne comunicasse l\'errata ricezione.<br>\nIl contenuto del presente messaggio non deve essere considerato come trasmesso o autorizzato da NETLand.<br>\nNETLand non si assume alcuna responsabilit\xE0 per eventuali intercettazioni, modifiche o danneggiamenti del presente messaggio e-mail.<br><br>\nThe information contained in this message is intended only for use of the individual(s) named above and may contain confidential, proprietary or legally privileged information.<br>\nNo confidentiality or privilege is waived or lost by any mistransmission. if you are not the intended recipient of this message you are hereby notified that you must not use, disseminate, copy it in any form or take any action in reliance of it. If you have received this message in error please delete it and any copies of it and notify the sender immediately.'
  }
});


/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(261);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(397);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(262);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(401);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(264);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(405);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(407);
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(267);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[276]);


// WEBPACK FOOTER //
// static/js/app.bd926569ab67a85355f4.js